import React from "react";
import "./styles.css";
import Ballot from "./Ballot";
import PluralityExplanation from "./PluralityExplanation";
import ApprovalExplanation from "./ApprovalExplanation";
import StarExplanation from "./StarExplanation";
import RcvExplanation from "./RcvExplanation";

export default function Tutorial({
  method,
  race,
  candidates,
  defaultRankings,
  onUpdate,
  next,
  prev,
  disableNext,
  isNew
}) {
  const methods = {
    plurality: {
      step: 1,
      method: "Plurality",
      ballotTitle: "Plurality Ballot",
      explanation: PluralityExplanation
    },
    approval: {
      step: 2,
      method: "Approval",
      ballotTitle: "Approval Ballot",
      explanation: ApprovalExplanation
    },
    star: {
      step: 3,
      method: "STAR",
      ballotTitle: "STAR Voting Ballot",
      explanation: StarExplanation
    },
    rcv: {
      step: 4,
      method: "Ranked Choice",
      ballotTitle: "Ranked Choice Ballot",
      explanation: RcvExplanation
    }
  };

  const info = methods[method];
  if (!info) {
    return "";
  }

  return (
    <div className="center">
      <h1 className="tutorial">
        <span className="blue">Method {info.step}&nbsp;of&nbsp;4:</span>{" "}
        <span className="red smallcap">{info.method}&nbsp;Voting</span>
      </h1>
      <hr />
      <div className="container">
        <div className="explanation">{info.explanation(isNew)}</div>
        <div className="ballotContainer">
          {/* <h2>{info.ballotTitle}</h2> */}
          <Ballot
            method={method}
            race={race}
            candidates={candidates}
            defaultRankings={defaultRankings}
            onUpdate={onUpdate}
          />
          <button
            onClick={next}
            disabled={disableNext}
            className={disableNext ? "noHover" : ""}
          >
            Vote
          </button>
          {method !== "plurality" && (
            <button onClick={prev} className="secondary">
              Go Back
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
